import { Assets, QubictronAppsUrlBuilder } from "@qubictron/url/client";

export { createScacIconUrl } from "@qubictron/url/client";

export const isAppComDomain = /qubictron\.com$/gi.test(window.location.hostname);

/**
 * The bundle, its stylesheet and the shared icons all come from the apps
 * origin — which on the local `.loc` stack is the site's own origin, because
 * nginx serves /apps, /icons and /fonts from the same host there.
 */
const originResolverCallbackMap = {
  localhost: () => ({ url: __APP_ORIGIN__ }),
  loc: () => ({ url: window.location.origin }),
};

export const assets = new Assets({
  appFolder: __APP_FOLDER__,
  hash: __DEV__ ? new Date().getTime().toString() : __APP_VERSION__,
  originResolverCallbackMap,
});

export const APP_STYLESHEET_HREF = assets.css.appBundleBuilder().build();

export const APP_FONTS_STYLESHEET_HREF = assets.css.fonts.bundleBuilder().build();

export const APP_FONTS_REGISTER_STYLESHEET_HREF = assets.css.fonts.bundleRegisterBuilder().build();

/**
 * Country flag for the Settings selects. The shared `createCountryFlagIconUrl`
 * builds the same path but without the resolver above, so on `.loc` it points
 * at the develop apps host instead of the local stack.
 */
export const createFlagIconUrl = (countryCode: string): string =>
  new QubictronAppsUrlBuilder({ originResolverCallbackMap })
    .setPathname(`icons/country-flags/${countryCode.toUpperCase()}.svg`)
    .build();

export const createCarrierIconUrl = (carrierCode: string): string =>
  new QubictronAppsUrlBuilder({ originResolverCallbackMap })
    .setPathname(`icons/sealine_icons/${carrierCode.toUpperCase()}.jpg`)
    .build();

/** Airlines by their two-letter IATA code, the one air cards carry as `carrier_scac`. */
export const createAirlineIconUrl = (airlineCode: string): string =>
  new QubictronAppsUrlBuilder({ originResolverCallbackMap })
    .setPathname(`icons/airline_icons/${airlineCode.toUpperCase()}.jpg`)
    .build();
